const APP_STORE_URL =
  'https://apps.apple.com/us/app/global-work-travel/id1535421676?itsct=apps_box_link&itscg=30200';
const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.globalworkandtravel.gapp';

const MobileIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M11.25 2.5H18.75C21.5 2.5 22.5 3.5 22.5 6.25V23.75C22.5 26.5 21.5 27.5 18.75 27.5H11.25C8.5 27.5 7.5 26.5 7.5 23.75V6.25C7.5 3.5 8.5 2.5 11.25 2.5Z"
        stroke="#575B63"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 23.75C15.6904 23.75 16.25 23.1904 16.25 22.5C16.25 21.8096 15.6904 21.25 15 21.25C14.3096 21.25 13.75 21.8096 13.75 22.5C13.75 23.1904 14.3096 23.75 15 23.75Z"
        stroke="#575B63"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 6.25H17.5"
        stroke="#575B63"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const AppleIcon = () => {
  return (
    <svg
      width="24"
      height="28"
      viewBox="0 0 24 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M19.9073 14.7574C19.8841 11.8991 22.2452 10.5093 22.3621 10.4401C21.0191 8.51007 18.9399 8.24007 18.2175 8.21557C16.4791 8.03507 14.7969 9.27557 13.9135 9.27557C13.0117 9.27557 11.6466 8.23457 10.1915 8.26507C8.29571 8.29557 6.52951 9.40507 5.55891 11.1311C3.55411 14.6401 5.04961 19.8216 6.96531 22.6616C7.92341 24.0556 9.03931 25.6141 10.4929 25.5571C11.9131 25.4941 12.4414 24.6431 14.1717 24.6431C15.8838 24.6431 16.3778 25.5571 17.8617 25.5211C19.3913 25.4941 20.3559 24.1186 21.2799 22.7126C22.3823 21.1051 22.8254 19.5281 22.8467 19.4471C22.8066 19.4336 19.9336 18.3156 19.9073 14.7574Z"
        fill="white"
      />
      <path
        d="M17.1596 6.38455C17.9412 5.41855 18.4695 4.11655 18.3219 2.79395C17.1965 2.84395 15.7938 3.57355 14.9785 4.52055C14.2534 5.36105 13.6146 6.70955 13.7827 7.97855C15.0429 8.07355 16.3438 7.33805 17.1596 6.38455Z"
        fill="white"
      />
    </svg>
  );
};

const GooglePlayIcon = () => {
  return (
    <svg
      width="24"
      height="26"
      viewBox="0 0 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M1.45178 0.824509C1.11178 1.18451 0.911774 1.74451 0.911774 2.46451V23.5345C0.911774 24.2545 1.11178 24.8145 1.45178 25.1745L1.53178 25.2545L13.3018 13.4845V13.2245V12.9645L1.53178 1.19451L1.45178 0.824509Z"
        fill="url(#paint0_linear_googleplay)"
      />
      <path
        d="M17.2318 17.4245L13.3018 13.4945V13.2345V12.9745L17.2318 9.04451L17.3318 9.10451L21.9718 11.7445C23.2918 12.4845 23.2918 13.6845 21.9718 14.4245L17.3318 17.0645L17.2318 17.4245Z"
        fill="url(#paint1_linear_googleplay)"
      />
      <path
        d="M17.3318 17.3645L13.3018 13.3345L1.45178 25.1745C1.87178 25.6145 2.57178 25.6745 3.35178 25.2345L17.3318 17.3645Z"
        fill="url(#paint2_linear_googleplay)"
      />
      <path
        d="M17.3318 9.10451L3.35178 1.23451C2.57178 0.794512 1.87178 0.854512 1.45178 1.29451L13.3018 13.1445L17.3318 9.10451Z"
        fill="url(#paint3_linear_googleplay)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_googleplay"
          x1="12.2718"
          y1="1.83451"
          x2="-2.09822"
          y2="16.2045"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.0066" stopColor="#00A1FF" />
          <stop offset="0.2601" stopColor="#00BEFF" />
          <stop offset="0.5122" stopColor="#00D2FF" />
          <stop offset="0.7604" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_googleplay"
          x1="23.6018"
          y1="13.2345"
          x2="0.561774"
          y2="13.2345"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.4087" stopColor="#FFBD00" />
          <stop offset="0.7754" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_googleplay"
          x1="15.0618"
          y1="15.4545"
          x2="-4.24822"
          y2="34.7645"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_googleplay"
          x1="-1.22822"
          y1="-5.37549"
          x2="6.69178"
          y2="2.54451"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.0685" stopColor="#2DA771" />
          <stop offset="0.4762" stopColor="#15CF74" />
          <stop offset="0.8009" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const StoreArrow = () => {
  return (
    <svg
      className="w-6 h-6 text-light-600 md:hidden"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 5l7 7-7 7"
      />
    </svg>
  );
};

const StoreLink = ({
  href,
  icon,
  title,
}: {
  href: string;
  icon: JSX.Element;
  title: string;
}) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="flex h-[50px] w-full items-center justify-between rounded-md bg-dark-900 px-6 transition-opacity hover:opacity-90"
    >
      <div className="flex items-center gap-3">
        {icon}
        <div className="flex flex-col text-light-600">
          <span className="text-[11px] leading-[15px]">Download on the</span>
          <span className="text-[17px] leading-[22px] font-semibold">
            {title}
          </span>
        </div>
      </div>
      <StoreArrow />
    </a>
  );
};

const DownloadAppSkeleton = () => {
  return (
    <div className="rounded-lg border border-dashed border-dark-500 bg-light-600 p-5">
      <div className="flex items-center gap-2.5">
        <div className="h-[30px] w-[30px] rounded-md bg-light-800 animate-pulse"></div>
        <div className="h-5 w-40 rounded-full bg-light-800 animate-pulse"></div>
      </div>

      <div className="mt-5 space-y-2">
        <div className="h-4 w-full rounded-full bg-light-800 animate-pulse"></div>
        <div className="h-4 w-11/12 rounded-full bg-light-800 animate-pulse"></div>
        <div className="h-4 w-4/5 rounded-full bg-light-800 animate-pulse"></div>
      </div>

      <div className="mt-5 flex flex-col gap-2">
        <div className="h-[50px] w-full rounded-md bg-light-800 animate-pulse"></div>
        <div className="h-[50px] w-full rounded-md bg-light-800 animate-pulse"></div>
      </div>
    </div>
  );
};

type Props = {
  isLoading?: boolean;
};

const DownloadApp = ({ isLoading = false }: Props) => {
  if (isLoading) return <DownloadAppSkeleton />;

  return (
    <div className="rounded-lg border border-dashed border-dark-500 bg-light-600 p-5">
      <div className="flex items-center gap-2.5">
        <MobileIcon />
        <h3 className="text-lg font-semibold text-dark-700">
          Download our App
        </h3>
      </div>

      <p className="mt-5 text-sm leading-[18px] text-dark-600">
        Everything you need for your trip, all in one place. Plan your
        adventure, access exclusive deals, learn a language, and connect with
        travellers on the same journey as you.
      </p>

      <div className="mt-5 flex flex-col gap-2">
        <StoreLink
          href={APP_STORE_URL}
          icon={<AppleIcon />}
          title="App Store"
        />
        <StoreLink
          href={GOOGLE_PLAY_URL}
          icon={<GooglePlayIcon />}
          title="Google Play"
        />
      </div>
    </div>
  );
};

export { DownloadApp };
